import { castArray, compact } from "lodash";

type LinkedContact = {
  id: string;
  displayValue?: string;
};

// Contacts linked at another contact (tixxt/core#654). The link is one-way, so
// this shows only what was entered at the contact being looked at.
export default function ContactRelation({ value }: { value: unknown }) {
  const contacts = compact(castArray(value) as LinkedContact[]).filter(
    (contact) => contact?.id,
  );
  if (!contacts.length) return null;

  return (
    <ul className="list-none m-0 p-0 flex flex-col gap-1">
      {contacts.map((contact) => (
        <li key={contact.id}>
          <a href={`/contacts/${contact.id}`}>
            {contact.displayValue || I18n.t("js.contacts.without_name")}
          </a>
        </li>
      ))}
    </ul>
  );
}
